
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CustomerGroup as CustomerGroupEnum } from '@/enums/CustomerGroup';
import { Venue } from '@/interfaces/models/Venue';

@Component
export default class HealthCheckFilter extends Vue {
  @Prop({ type: Array, required: true }) public customerGroups!: CustomerGroupEnum[];
  @Prop({ type: Object, required: false }) public venue!: Venue;
  @Prop({ type: Array, required: true }) public venues!: Venue[];

  public selectedCustomerGroup: string = '';
  public selectedVenues: string[] = [];

  public mounted() {
    if (!this.venue) {
      this.$startLoading('venue');
    } else {
      this.setDefaultCustomerGroup();
    }
  }

  public setDefaultCustomerGroup() {
    if (this.venue.customerGroup) {
      this.selectedCustomerGroup = this.venue.customerGroup || '';
    }
  }

  @Watch('venue')
  public async onVenueChange() {
    if (this.venue && this.venue._id) {
      this.setDefaultCustomerGroup();
    }
  }

  @Watch('selectedCustomerGroup')
  public onCustomerGroupChange() {
    const customerGroup = this.selectedCustomerGroup;
    const venues = this.selectedVenues;

    if (!customerGroup) {
      if (!venues.length) {
        return this.setDefaultCustomerGroup();
      }

      return this.$emit('filter', { venues });
    }

    if (venues.length) {
      this.selectedVenues = [];
    }

    this.$emit('filter', { customerGroup });
  }

  @Watch('selectedVenues')
  public onVenuesChange() {
    const venues = this.selectedVenues;
    const customerGroup = this.selectedCustomerGroup;

    if (!venues.length) {
      if (!customerGroup) {
        return this.setDefaultCustomerGroup();
      }

      return this.$emit('filter', { customerGroup });
    }

    if (customerGroup) {
      this.selectedCustomerGroup = '';
    }

    this.$emit('filter', { venues });
  }
}
